import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { updateAccount } from '../../controllers/user';
import Loading from '../loading/Loading';
import { manuallyRegisterMembershipPayment } from '../../controllers/orders';

const RegistroMembresiaManual = forwardRef((props, ref) => {
  const [comments, setComments] = useState('');
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  console.log(props.membership);

  async function submitUpdate() {
    setLoading(true);
    try {
      await manuallyRegisterMembershipPayment(token, props.membership, comments);
      props.completedMembershipUpdate('registro-manual');
    }
    catch (e) {
      props.completedMembershipUpdate('registro-manual', e);
    }
    setLoading(false);
  }

  if (loading) {
    return <Row>
      <Loading text="Registrando orden manualmente ..." />
    </Row>
  }

  return <Row>
    <Col>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Comentarios</Form.Label>
        <Form.Control type="text" placeholder="Agrega un comentario." value={comments} onChange={e => setComments(e.target.value)} required />
      </Form.Group>
      <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-membresia-manual' type='submit' variant='primary' onClick={submitUpdate}>Actualizar membresía</Button>
      </Form.Group>
    </Col>
  </Row>;
});

export default RegistroMembresiaManual;